/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_S3_Li3Inputs */

const en_guide_large_json_files_s3_li3 = /** @type {(inputs: Guide_Large_Json_Files_S3_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Command line</strong>: Use <code>jq</code> for filtering and transforming large JSON from the terminal`)
};

const ko_guide_large_json_files_s3_li3 = /** @type {(inputs: Guide_Large_Json_Files_S3_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>커맨드 라인</strong>: 터미널에서 대용량 JSON 필터링 및 변환을 위해 <code>jq</code> 사용`)
};

const ja_guide_large_json_files_s3_li3 = /** @type {(inputs: Guide_Large_Json_Files_S3_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>コマンドライン</strong>: ターミナルから大きなJSONのフィルタリングや変換に<code>jq</code>を使用`)
};

/**
* | output |
* | --- |
* | "<strong>Command line</strong>: Use <code>jq</code> for filtering and transforming large JSON from the terminal" |
*
* @param {Guide_Large_Json_Files_S3_Li3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_s3_li3 = /** @type {((inputs?: Guide_Large_Json_Files_S3_Li3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_S3_Li3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_s3_li3(inputs)
	if (locale === "ko") return ko_guide_large_json_files_s3_li3(inputs)
	return ja_guide_large_json_files_s3_li3(inputs)
});